import { gql } from '@apollo/client';

export const getOutageTicketsQuery = gql`
  query GetOutageTickets {
    getOutageTickets {
      outages {
        ticketId
        createdDate
        expectedResolvedDateTime
        resolvedDateTime
        productTypes
        isResolved
        phoneNumbers
        calculatedResolvedDateTime
      }
      plannedMaintenances {
        plannedStartDate
        duration
      }
    }
  }
`;
